<template>
  <svg
    class="base-koblenz-arrow"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 283.5 283.5"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M30.3 0 158.1 140.3 19.1 283.5 153.4 283.5 283.5 143.7 161.7 0z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
defineOptions({
  name: 'BaseKoblenzArrow',
})

defineProps({
  color: {
    type: String,
    default: 'currentColor',
  },
})
</script>

<style scoped>
.base-koblenz-arrow {
  display: block;
  width: 0.9em;
  height: auto;
  flex: 0 0 auto;
}
</style>
